// extracted by mini-css-extract-plugin
export default {"root":"VerificationCard_root__8RMXW"};